import { Routes } from '@angular/router';
import { ShellGuard } from './shell-guard.service';
var ɵ0 = {
    // "argument" for shell guard to avoid duplicating reroute logic
    loggedIn: true,
}, ɵ1 = function () {
    return import("./logged-in-routing.module.ngfactory").then(function (m) { return m.LoggedInRoutingModuleNgFactory; });
}, ɵ2 = {
    loggedIn: false,
}, ɵ3 = function () {
    return import("./logged-out-routing.module.ngfactory").then(function (m) { return m.LoggedOutRoutingModuleNgFactory; });
};
var appRoutes = [
    {
        path: '',
        children: [
            {
                path: '',
                canActivate: [ShellGuard],
                // always run guard so we can swap shells when auth state changes
                runGuardsAndResolvers: 'always',
                data: ɵ0,
                // if logged in, lazy-load the logged in shell
                loadChildren: ɵ1,
            },
            {
                path: '',
                canActivate: [ShellGuard],
                runGuardsAndResolvers: 'always',
                data: ɵ2,
                loadChildren: ɵ3,
            },
        ],
    },
];
var ShellRoutingModule = /** @class */ (function () {
    function ShellRoutingModule() {
    }
    return ShellRoutingModule;
}());
export { ShellRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
